import React from 'react';
import clsx from 'clsx';

const Th = ({ children, extraClasses, isLeft }) => {
  return <div className={clsx('th', isLeft && 'th--left', extraClasses)}>{children}</div>;
};

export default Th;
